import React from 'react';
import { useTranslation } from 'react-i18next';
import './DisabledByGradeBanner.scss';

/**
 * This component shows a banner if there is any grade that is disabled
 */
export default function DisableByGradeBanner({ disabledGrades, hasWindowSet }) {


  const { t } = useTranslation('common', 'admin_benchmark_configuration');

  const hasWindowDisabledByGrade = disabledGrades?.some(disabled => disabled);
  if(!hasWindowSet || !hasWindowDisabledByGrade) {
    return null;
  }

  // the disabledGrades is a array of booleans where true is disabled and false is enabled
  // map the disabledGrades to the grade number grade_x where x is the index of the grade
  disabledGrades = disabledGrades.map((disabled, index) => disabled ? t(`grade_${index}`) : null).filter(Boolean);
  const disabledGradesString = disabledGrades.join(', ');

  return (
    <div className="disabled-by-grade-banner" role="alert">
      <p>
        {t(`window_disabled_by_grade_warning`, { disabledGradesString, count: disabledGrades.length, ns: 'admin_benchmark_configuration'})}
      </p>
    </div>
  );

}